import { ColumnDef } from "@tanstack/react-table"
import { GetReturnedOrdersQuery } from "src/graphql/quark/quark.type"
import { IconButton, Tooltip, Typography } from "@mui/material"
import { toast } from "react-toastify"
import { getDisplayPrice } from "src/shared/utils/helpers-functions"
import { capitalizeFirstLetter } from "src/shared/utils/data-helpers"
import moment from "moment"
import { truncateString } from "src/shared/utils/string-functions"
import ROUTE_PATHS from "src/routes/route-path"
import { Visibility } from "@mui/icons-material"
import { ChipStyled } from "src/shared/components"
const getReturnOrderListColumns = ({
  onDetailClick
}: {
  onDetailClick: (id: string) => void
}): ColumnDef<GetReturnedOrdersQuery["getReturnedOrders"]["data"][0]>[] => {
  return [
    {
      id: "secondaryId",
      accessorKey: "secondaryId",
      header: "ID",
      meta: { width: "70", minWidth: "70px", textAlign: "center", headerAlign: "center" },
      cell: (info) => (
        <Tooltip title={info.getValue() as string}>
          <Typography
            variant="body2"
            onClick={() => {
              navigator.clipboard.writeText(info.getValue() as string).then(() => {
                toast.success("Copy to Clipboard")
              })
            }}
          >
            {info.getValue() as string}
          </Typography>
        </Tooltip>
      )
    },
    {
      id: "parentOrderId",
      accessorKey: "parentOrderId",
      header: "Order ID",
      accessorFn: (val) => truncateString(val?.parentOrderId ?? "", 10),
      cell: (info) => (
        <Typography
          sx={{ cursor: "pointer" }}
          title="Click to open order"
          variant="body2"
          onClick={() =>
            window.open(ROUTE_PATHS.ORDER_MANAGEMENT.DETAILS(info.row?.original?.parentOrderId as string), "_bank")
          }
        >
          {info?.getValue() as string}
        </Typography>
      )
    },
    {
      id: "customerName",
      accessorKey: "customerName",
      header: "Customer Name",
      accessorFn: (val) => val?.customer?.name
    },
    {
      id: "customerPhoneNo",
      accessorKey: "customerPhoneNo",
      header: "Customer Phone",
      accessorFn: (val) => val?.customer?.phoneNumber
    },
    {
      id: "customerName",
      accessorKey: "customerName",
      header: "Customer Name",
      accessorFn: (val) => val?.customer?.name
    },
    {
      id: "amount",
      accessorKey: "amount",
      header: "Amount",
      accessorFn: (val) => getDisplayPrice(val.totalAmount ?? "")
    },
    {
      id: "status",
      accessorKey: "status",
      header: "Status",
      cell: (info) => (
        <ChipStyled
          label={capitalizeFirstLetter(((info.getValue() as string) || "").replace("_", " "))}
          size="small"
          background="default"
        />
      )
    },
    {
      id: "comment",
      accessorKey: "comment",
      header: "Comment"
    },
    {
      id: "updatedAt",
      accessorKey: "updatedAt",
      header: "Updated At",
      accessorFn: (val) => (val.updatedAt ? moment(val.updatedAt).format("lll") : "-")
    },
    {
      id: "CreatedAt",
      accessorKey: "CreatedAt",
      header: "Created At",
      accessorFn: (val) => (val.createdAt ? moment(val.createdAt).format("lll") : "-")
    },
    {
      id: "action",
      accessorKey: "action",
      header: "Action",
      cell: (info) => (
        <IconButton size="small" sx={{ p: 0.5 }} onClick={() => onDetailClick(info.row?.original?.id as string)}>
          <Visibility sx={{ fontSize: 18 }} />
        </IconButton>
      )
    }
  ]
}

export default getReturnOrderListColumns
